import AccountContactForm from "@app/components/forms/account/account-contact-form.tsx";
import AccountNotificationForm from "@app/components/forms/account/account-notification-form.tsx";
import AccountPersonalForm from "@app/components/forms/account/account-personal-form.tsx";
import AccountProfileForm from "@app/components/forms/account/account-profile-form.tsx";
import PageTitle from "@app/components/page-title.tsx";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Tab } from "@mui/material";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";

interface SearchParams {
    tab?: string;
}

export const Route = createFileRoute("/_authenticated/account/profile")({
    component: Component,
    validateSearch: (search: Record<string, unknown>): SearchParams => {
        return {
            tab: search.tab as string | undefined,
        };
    },
});

function Component() {
    const search = Route.useSearch();
    const [activeTab, setActiveTab] = useState(search.tab ?? "contact");

    const navigate = useNavigate();

    const handleChangeTab = (tab: string) => {
        setActiveTab(tab);
        void navigate({ to: ".", search: { ...search, tab } });
    };

    return (
        <>
            <PageTitle>Profile</PageTitle>
            <TabContext value={activeTab}>
                <TabList onChange={(_e, value) => handleChangeTab(value)}>
                    <Tab value={"contact"} label={"Contact"} />
                    <Tab value={"personal"} label={"Personal"} />
                    <Tab value={"profile"} label={"Profile"} />
                    <Tab value={"notification"} label={"Notification"} />
                </TabList>
                <TabPanel value={"contact"}>
                    <AccountContactForm />
                </TabPanel>
                <TabPanel value={"personal"}>
                    <AccountPersonalForm />
                </TabPanel>
                <TabPanel value={"profile"}>
                    <AccountProfileForm />
                </TabPanel>
                <TabPanel value={"notification"}>
                    <AccountNotificationForm />
                </TabPanel>
            </TabContext>
        </>
    );
}
